/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import style from './cabinet.module.scss';
import UserCard from './localComponents/userCard';
import UploadWarning from './localComponents/uploadWarning';
import { Link, useNavigate } from 'react-router-dom';
import { useAppSelector } from 'store/hooks';
import { selectCategories, selectResourceByName } from 'store/page/pageSlice';
import Button from 'controls/buttons/submit';
import AddImageIcon from 'icons/addImage';
import GridSection from 'components/gridSection/gridSection';
import { useRights } from 'hooks/useRights';
import UploadArea from 'components/uploadArea/uploadArea';
import UploadModal from 'components/modal/uploadModal';
import map from 'lodash-es/map';
import TabsComponent from 'controls/tabs/tabs';
import { useCurrentCategory } from 'hooks/useCategoryId';
import { CategoryId } from 'store/types';
import { getAccept, MIN_SCREEN_WIDTH, MIN_TABLET_WIDTH } from 'utils/utils';
import cx from 'classnames';
import LikedSectionPlug from 'components/plugs/likedSectionPlug/likedSectionPlug';
import { useViewport } from 'contexts/viewportContext';

export default function Cabinet() {
  const { width } = useViewport();
  const rights = useRights();
  const [currentModal, setCurrentModal] = useState<null | React.ReactElement>(
    null
  );
  const categories = useAppSelector(selectCategories);
  const navigate = useNavigate();

  const currentCategory = useCurrentCategory();

  const liked = useAppSelector(selectResourceByName.bind(null, 'only_liked'));
  const uploaded = useAppSelector(
    selectResourceByName.bind(null, 'only_uploaded')
  );

  const isLikedSection = liked === undefined || liked?.total;
  const isUploadedSection = uploaded === undefined || uploaded?.total;

  //   const isAdaptiveModeOn = window.innerWidth < MIN_SCREEN_WIDTH;
  //   const isMobileAdaptiveModeOn = window.innerWidth < MIN_TABLET_WIDTH;
  const isAdaptiveModeOn = width <= MIN_SCREEN_WIDTH;
  const isMobileAdaptiveModeOn = width <= MIN_TABLET_WIDTH;

  const shouldAdminLinkRender = rights.toAdmin && !isMobileAdaptiveModeOn;

  return (
    <div className={cx(style.container, 'adaptive-cabinet__container')}>
      {currentModal !== null && currentModal}
      <div className={style.topbar}>
        <div className={cx(style.profile, 'adaptive-cabinet__profile')}>
          <span className={style.greeting}>Профиль</span>
          {shouldAdminLinkRender && (
            <Link
              to="/admin"
              className={cx(
                style.administrating,
                'clickable-text',
                'adaptive-cabinet__administrating'
              )}
            >
              Перейти к администрированию
            </Link>
          )}
          <UserCard></UserCard>
        </div>
      </div>

      <TabsComponent<CategoryId>
        className={'adaptive-cabinet__tabs'}
        groupName="category"
        defaultValue={currentCategory.id}
        variants={map(categories, (c) => {
          return {
            id: c.id,
            value: c.id,
            text: c.id,
          };
        })}
        onChange={(e, value) => {
          navigate(
            `/cabinet?category=${categories[value]?.id || 'Фотографии'}`,
            {
              replace: false,
            }
          );
        }}
      ></TabsComponent>

      {isLikedSection ? (
        <GridSection
          text="Понравившиеся"
          href={`/search?category=${currentCategory.id}&only_liked=true`}
          resourceName="only_liked"
          shouldImagesScroll={isMobileAdaptiveModeOn}
        ></GridSection>
      ) : (
        <LikedSectionPlug></LikedSectionPlug>
      )}

      {isUploadedSection ? (
        <>
          <GridSection
            text="Ваш контент"
            href={`/search?category=${currentCategory.id}&only_uploaded=true`}
            resourceName="only_uploaded"
            shouldImagesScroll={isMobileAdaptiveModeOn}
          ></GridSection>
          <div className={style.upload}>
            {rights.upload ? (
              !isAdaptiveModeOn ? (
                <Button
                  startIcon={<AddImageIcon />}
                  onClick={() => {
                    setCurrentModal(
                      <UploadModal
                        accept={getAccept(currentCategory.id)}
                        onClose={() => {
                          setCurrentModal(null);
                        }}
                        onUpload={() => {
                          navigate(`/upload#${currentCategory.id}`, {
                            replace: false,
                          });
                        }}
                      ></UploadModal>
                    );
                  }}
                >
                  Загрузить
                </Button>
              ) : (
                <UploadWarning></UploadWarning>
              )
            ) : (
              ''
            )}
          </div>
        </>
      ) : rights.upload ? (
        <>
          <div className={style.emptyHeader}>
            <span>Ваш контент</span>
          </div>
          {!isAdaptiveModeOn ? (
            <UploadArea
              accept={getAccept(currentCategory.id)}
              onClose={() => {
                setCurrentModal(null);
              }}
              onUpload={() => {
                navigate(`/upload#${currentCategory.id}`, {
                  replace: false,
                });
              }}
            ></UploadArea>
          ) : (
            <UploadWarning></UploadWarning>
          )}
        </>
      ) : (
        ''
      )}
    </div>
  );
}
